import React from "react";
import DSBox from "../../views/system-design/DSBox";
import DSTypography from "../../views/system-design/DSTypography";
import KSocialIcon from "./KSocialIcons";

type SocialLink = { link: string; network: string };

interface ReviewSocialLinksProps {
  links?: SocialLink[];
  title?: string;
}

const toHref = (link: string): string =>
  /^https?:\/\//i.test(link) ? link : `https://${link}`;

const ReviewSocialLinks: React.FC<ReviewSocialLinksProps> = ({
  links,
  title = "Creator's Social Links",
}) => {
  const items = (links ?? []).filter((item) => item?.link?.trim());

  if (!items.length) {
    return null;
  }

  return (
    <DSBox sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      <DSTypography variant="subtitle2" sx={{ fontWeight: 600 }}>
        {title}
      </DSTypography>
      {items.map((item) => (
        <DSBox
          key={`${item.network}-${item.link}`}
          sx={{ display: "flex", alignItems: "center", gap: 1 }}
        >
          <KSocialIcon
            url={toHref(item.link)}
            title={item.network}
            style={{ height: 28, width: 28 }}
          />
          <a
            href={toHref(item.link)}
            target="_blank"
            rel="noopener noreferrer"
            style={{ wordBreak: "break-all" }}
          >
            {item.link}
          </a>
        </DSBox>
      ))}
    </DSBox>
  );
};

export default ReviewSocialLinks;
